//@flow
import React, { Component } from "react";
import "./list-content.scss";
import ListItem from "../list-item";
import type { ProductType } from "../types/product.js";
import type { PricingType } from "../types/pricing.js";
import type { ProductPurchasability } from "../types/publicpurchasable";

type Props = {
  products: Array<ProductType>,
  pricesMap: Map<number, PricingType>,
  productPurchasabilityMap: Map<number, ProductPurchasability>,
  isPostCodeAvailable: boolean,
  onRemove: (productCode: number) => void,
  onShowPostcodeClicked: () => void,
  onQuantityChanged: (productCode: number, newQuantity: number) => void,
  isLoadingPurchasability: boolean,
  isLoggedInUser: boolean
};

class ListContent extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const products: Array<ProductType> = this.props.products;
    const { onRemove, onQuantityChanged, onShowPostcodeClicked } = this.props;

    const itemLists = products.map(productData => {
      let pricing = this.props.pricesMap.get(productData.productCode);
      let purchasability =
        this.props.productPurchasabilityMap.get(productData.productCode) ||
        "Shop in maX";

      return (
        <div
          key={productData.productCode}
          className="wishlist-tile wishlist-main__list-item"
        >
          <ListItem
            product={productData}
            pricing={pricing}
            purchasability={purchasability}
            isPostCodeAvailable={this.props.isPostCodeAvailable}
            onRemove={onRemove}
            onShowPostcodeClicked={onShowPostcodeClicked}
            onQuantityChanged={onQuantityChanged}
            isLoadingPurchasability={this.props.isLoadingPurchasability}
            isLoggedInUser={this.props.isLoggedInUser}
          />
        </div>
      );
    });
    return <div className="wishlist-main__list-content">{itemLists}</div>;
  }
}

export default ListContent;
